import React from 'react';
import { Checkbox } from 'antd';
import { productsHelper } from '../../../../helpers';
import { inject } from 'mobx-react';

export const HeltyProductCardWithSelectableRatePlan = inject(
  'translationsStore',
  'productsStore'
)(
  ({
    translationsStore,
    productsStore,
    productWithRatePlans,
    onCheckedChange,
    checkedRatePlanId,
    isHighlighted,
    monthlyPrice,
    yearlyPrice,
    ...props
  }) => {
    if (!productWithRatePlans) {
      return <></>;
    }

    const showGratisPromo = productsStore.shouldShowEltyBundle(
      productWithRatePlans
    );

    const monthlyRatePlan = productsHelper.getRecurringRatePlanFromProduct(
      productWithRatePlans
    );
    const yearlyRatePlan = productsHelper.getAnnualRatePlanFromProduct(
      productWithRatePlans
    );

    /*   useEffect(() => {
      if (showGratisPromo && yearlyRatePlan) {
        console.log(
          'Elty bundle is active, setting yearly rate plan as checked by default'
        );
        onCheckedChange(productWithRatePlans, yearlyRatePlan);
      }
    }, [
      showGratisPromo,
      productWithRatePlans,
      yearlyRatePlan,
      onCheckedChange,
    ]); */

    return (
      <>
        <div
          style={{
            border: isHighlighted ? '2px solid #00B3B0' : '1px solid #eaeaea',
            borderRadius: '8px',
            padding: '24px',
            margin: '16px 0',
            maxWidth: '650px',
            boxShadow: isHighlighted
              ? '0 4px 12px rgba(0, 179, 176, 0.2)'
              : '0 2px 8px rgba(0, 0, 0, 0.05)',
            backgroundColor: '#fff',
          }}
          {...props}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '20px',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                marginRight: '20px',
              }}
            >
              <img
                src='/products/elty_logo_title.png'
                width={60}
                alt='elty logo'
              />
            </div>
            <h2
              style={{ marginBottom: 0, fontSize: '24px', fontWeight: 'bold' }}
            >
              Piano Family
            </h2>
            <div
              style={{
                marginLeft: 'auto',
              }}
            >
              <img
                src='/products/heart_icon.png'
                alt='heart logo'
                style={{ width: '50px' }}
              />
            </div>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <p style={{ fontWeight: '500', fontSize: '16px' }}>
              Questo servizio dà accesso a chat e video illimitati con un medico
              a supporto della maternità e un pediatra online.
            </p>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <ul
              style={{
                listStyleType: 'disc',
                paddingLeft: '20px',
                fontSize: '16px',
                lineHeight: '2',
              }}
            >
              <li>Chat e televisite illimitate con medico e pediatra online</li>
              <li>Servizio attivo tutti i giorni dalle 8:00 alle 22:00</li>
              <li>Televisite in 24 ore con il medico e pediatra online</li>
              <li>
                Accesso all'app di salute con diversi servizi a disposizione
              </li>
            </ul>
          </div>
        </div>
        <div
          style={{
            marginBottom: '30px',
            fontSize: '16px',
            padding: '16px 0 0 0',
          }}
        >
          {showGratisPromo ? (
            <div style={{ textAlign: 'center', padding: '10px 0' }}>
              <div style={{ margin: '20px 0' }}>
                <Checkbox
                  onChange={onCheckedChange(
                    productWithRatePlans,
                    monthlyRatePlan
                  )}
                  checked={checkedRatePlanId === monthlyRatePlan.id}
                  style={{ marginRight: '10px' }}
                />
                <span
                  style={{
                    color: '#00B3B0',
                    fontWeight: 'bold',
                    fontSize: '18px',
                  }}
                >
                  Gratis per 6 mesi senza costi aggiuntivi
                </span>
                <span style={{ color: '#333', fontSize: '16px' }}>
                  , poi 9,99€/mese
                </span>
              </div>
              <div style={{ margin: '15px 0' }}>Disdici quando vuoi</div>
            </div>
          ) : (
            <>
              <p
                style={{
                  fontWeight: '500',
                  fontSize: '16px',
                  textAlign: 'center',
                }}
              >
                {translationsStore.translate(
                  'productCardWithSelectableRatePlan.chooseTheBestPlanForYou'
                )}
              </p>

              {yearlyPrice && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    margin: '16px 0',
                    padding: '8px',
                    border:
                      checkedRatePlanId === yearlyRatePlan.id
                        ? '1px solid #00B3B0'
                        : '1px solid transparent',
                    borderRadius: '4px',
                  }}
                >
                  <Checkbox
                    onChange={onCheckedChange(
                      productWithRatePlans,
                      yearlyRatePlan
                    )}
                    checked={checkedRatePlanId === yearlyRatePlan.id}
                  />
                  <div style={{ marginLeft: '10px' }}>
                    <span
                      style={{
                        color: '#00B3B0',
                        fontWeight: 'bold',
                        fontSize: '18px',
                      }}
                    >
                      {productsHelper.convertPriceToUseComa(yearlyPrice)} €
                    </span>{' '}
                    {translationsStore.translate('common.forOne')}{' '}
                    {translationsStore.translate('common.year')}
                  </div>
                </div>
              )}
              {monthlyPrice && (
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    margin: '16px 0',
                    padding: '8px',
                    border:
                      checkedRatePlanId === monthlyRatePlan.id
                        ? '1px solid #00B3B0'
                        : '1px solid transparent',
                    borderRadius: '4px',
                  }}
                >
                  <Checkbox
                    onChange={onCheckedChange(
                      productWithRatePlans,
                      monthlyRatePlan
                    )}
                    checked={checkedRatePlanId === monthlyRatePlan.id}
                  />
                  <div style={{ marginLeft: '10px' }}>
                    <span
                      style={{
                        color: '#00B3B0',
                        fontWeight: 'bold',
                        fontSize: '18px',
                      }}
                    >
                      {productsHelper.convertPriceToUseComa(monthlyPrice)} €/
                      {translationsStore.translate('common.month')}
                    </span>{' '}
                    {translationsStore.translate('common.forOne')}{' '}
                    {translationsStore.translate('common.year')}
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </>
    );
  }
);
